import { Outlet } from 'react-router-dom';
import AppAppBar from '../components/marketing-page/components/AppAppBar';
import Footer from '../components/marketing-page/components/Footer';
import AppErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';

export const MainLayout = () => {
  return (
    <>
      <AppAppBar />
      <AppErrorBoundary>
        <Outlet />
      </AppErrorBoundary>
      <Footer />
    </>
  );
};
